import React from 'react';
import { useNavigate } from 'react-router-dom';
import ListModal from './ListModal';
import { fmtDate } from '../lib/when';

const slug = (v) => String(v || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
const hours = (v) => (v === null || v === undefined ? '—' : `${Number(v).toFixed(1)}h`);

/**
 * The work orders behind a number on the analytics dashboard. Each row opens
 * the work order; the ticket it was raised from is shown alongside so the row
 * is recognisable without opening it.
 */
export default function WorkOrderListModal({ title, subtitle, workOrders, loading, error, onClose }) {
  const navigate = useNavigate();
  const open = (id) => { onClose(); navigate(`/work-orders/${id}`); };

  return (
    <ListModal
      title={title}
      subtitle={subtitle}
      count={loading ? null : workOrders.length}
      noun="work order"
      onClose={onClose}
    >
      {loading ? (
        <p className="tlm-empty">Loading work orders…</p>
      ) : error ? (
        <p className="tlm-empty">{error}</p>
      ) : workOrders.length === 0 ? (
        <p className="tlm-empty">Nothing here for this selection.</p>
      ) : (
        <table className="tlm-table">
          <thead>
            <tr>
              <th>Work order</th>
              <th>Ticket</th>
              <th>Status</th>
              <th>Contractor</th>
              <th>Allocated</th>
              <th>Logged</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {workOrders.map((w) => (
              <tr
                key={w.id}
                className="tlm-row"
                role="link"
                tabIndex={0}
                title={`Open ${w.work_order_number || 'work order'}`}
                onClick={() => open(w.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(w.id); }
                }}
              >
                <td className="tlm-number">{w.work_order_number || '—'}</td>
                <td className="tlm-ticket-title">
                  {w.ticket_number ? `${w.ticket_number} · ` : ''}{w.ticket_title || '—'}
                </td>
                <td>
                  <span className="ticket-status-badge" data-status={slug(w.status)}>
                    {(w.status || '—').replace(/_/g, ' ')}
                  </span>
                </td>
                <td className="tlm-contractor">{w.contractor_name || '—'}</td>
                <td className="tlm-date">{hours(w.allocated_hours)}</td>
                <td className="tlm-date">{hours(w.logged_hours)}</td>
                <td className="tlm-date">
                  {w.created_at ? fmtDate(w.created_at) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </ListModal>
  );
}
